import assignBox from './assignBox';
import history from './history';
import kpi from './kpi';
import dataExport from './dataExport';
import dataUpload from './dataUpload';
import vehicleMarkerPopup from './vehicleMarkerPopup';
import mapLayers from './mapLayers';
import changeViewDropdown from './changeViewDropdown';
import dualList from './dualList';
import feedbackCard from './feedbackCard';

const index = {
  assignBox,
  history,
  kpi,
  dataExport,
  dataUpload,
  vehicleMarkerPopup,
  mapLayers,
  changeViewDropdown,
  dualList,
  feedbackCard,
};

export default index;
